import React from 'react';
import { merge } from 'lodash';
import { defaultZRGlobal, ZRGlobal, ZRPage } from './d';

interface ZRPageContext {
  page: Partial<ZRPage>,
}

export const PageContext = React.createContext<ZRGlobal>(defaultZRGlobal);

export const usePageContext = (): ZRGlobal => React.useContext(PageContext);

export const PageContextProvider = (
  { context, children }: { context: ZRPageContext, children: React.ReactNode },
): JSX.Element => {
  const value = merge(defaultZRGlobal, context);

  return (
    <PageContext.Provider value={value}>{children}</PageContext.Provider>
  );
};

export type { ZRGlobal } from './d';
